import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { ApiService } from 'src/app/api.service';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';
import { MessageService, ConfirmationService } from "primeng/api";
import { TovpilCookieService } from 'src/app/utils/tovpil-cookie.service';
import { GuideMediaVO } from 'src/app/shared/models/GuideMediaVO';

@Component({
  selector: 'app-audios-grants-extern-guides',
  templateUrl: './audios-grants-extern-guides.component.html',
  styleUrls: ['./audios-grants-extern-guides.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilCookieService],
})
export class AudiosGrantsExternGuidesComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};

  /** COMPONENT EXPORT*/
  blocked : boolean = true;
  uploadedFiles: any[] = [];
  listGuidesMedia =[];
  listExcelRows =[];
  listExternGuides:GuideMediaVO[] = [];
  expandedRows = {};

  /** LABELS */
  translations: Record<string, string> = {};

  constructor(
      private messageService: MessageService,
      private apiService: ApiService,
      private authenticationService: AuthenticationService,
      private tovpilUtils: TovpilUtilsService,
      private userPreferencesService: UserPreferencesService,
      private router: Router,
      private translationService: TovpilLanguageService) {
        this.initConfigs();
      }

  async ngOnInit(): Promise<void> {
    await this.getTranslatedLabels();

    this.blocked = false;
  }

  /**
   * The function initializes form groups for configuration and data, and updates the configuration form
   * with query parameters from the route.
   */
  async initConfigs() {
    this.globalUserPreferences =
      (await this.userPreferencesService.getSantovTovpilCookie()) || null;
  }

  /**
   * The function asynchronously retrieves translated labels using a translation
   * service, handling any errors that may occur.
   */
  async getTranslatedLabels() {
    try {
      console.log(this.globalUserPreferences);
      await this.translationService.getTranslatedLabels(this.globalUserPreferences.preferences.language, this.globalUserPreferences.preferences.region);
      this.translations = this.translationService.getLabels();

    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
      // Error al traer labels traducidos
    }
  }

  /**
   * The function `onFileSelect` reads an Excel file, processes its content, and handles any errors that
   * may occur during the process.
   * @param event - The `onFileSelect` function is triggered when a file is selected. The `event`
   * parameter in this function represents the event object that is generated when the file selection
   * event occurs. It contains information about the selected file, such as its name, size, type, and
   * other properties. In this
   */
  onFileSelect(event) {
    this.blocked = true;
    let selectedFile : any;
    selectedFile = event.files[0];
    let reader = new FileReader();
    reader.readAsBinaryString(selectedFile);
    let self = this;
    let errorHappen: boolean = false;
    reader.onload = function (e) {

      import("xlsx").then(xlsx => {
        const workbook = xlsx.read(reader.result, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyy', });
        const sheetnames = Object.keys(workbook.Sheets);
        const sheetname = sheetnames[0];
        let respuesta: JSON[] = xlsx.utils.sheet_to_json(workbook.Sheets[sheetname], { defval: "", blankrows: false, header: 1 });

        respuesta.shift();
        self.listExcelRows = respuesta;
        self.validateContent();


      }).catch(error => {
        console.error(error);
        errorHappen = true;
      });

    }
    if (errorHappen) {
      this.blocked = false;
    }
    this.blocked = false;
  }


  async validateContent(){
    console.log("Armaremos el contenido a enviar a validar");
    let listGuideMedia =this.listExcelRows.map( (row) => {
        return {"guideId": String(row[0]), "itemId": String(row[1]) }
    });
    let req = {
      "token" : this.globalUserPreferences.tokenProfile,
      "language" : this.globalUserPreferences.preferences.language,
      "guideMediaXls" : listGuideMedia
    }
    console.log(req);
    let data : any = await this.apiService.validateExternGuidesAndMedia(req);
    this.listExternGuides = data;
    
    
  }


  clearTable() {
    /*this.listExternGuides = [];
    this.listImportGuides.length = 0;
    this.uploadedFiles = [];*/
  }

  capitalizeFirstLetter(inputString) {
    if (inputString.length > 0) {
      return inputString.charAt(0).toUpperCase() + inputString.slice(1);
    } else {
      return inputString;
    }
  }

}
